<script>
import moment from 'moment'
import OilVolumeChange from '@router/pages/reports/views/OilVolumeChange'

export default {
  name: 'OilVolumeChangeChart',
  components: {
    OilVolumeChange,
  },
  props: {
    workshopId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      widgetParams: {
        reportName: 'OilVolumeChange',
        params: {
          aspectRatio: 2.0,
          granularity: 'day',
          start_date: this.weekAgo(),
          end_date: this.today(),
        },
        dateLabel: this.getDateRange(),
      },
      overrideParams: {
        filter_organisation_value: this.workshopId,
        filter_organisation_comparison: 'EQ',
      },
    }
  },
  methods: {
    today() {
      return moment().endOf('day')
    },
    todayDateParam() {
      return this.today().format('YYYY-MM-DD')
    },
    todayDate() {
      return this.today().format('YYYY-MM-DD')
    },
    weekAgo() {
      return moment()
        .add(-7, 'day')
        .startOf('day')
    },
    weekAgoDateParam() {
      return this.weekAgo().format('YYYY-MM-DD')
    },
    weekAgoDate() {
      return this.weekAgo().format('YYYY-MM-DD')
    },
    getDateRange() {
      return this.weekAgoDate() + ' - ' + this.todayDate()
    },
    navigateToReport() {
      this.$store.commit('settings/SET_SETTINGS', {
        name: this.widgetParams.reportName,
        params: { ...this.widgetParams.params, ...this.overrideParams },
      })
      this.$store.commit('filters/SET_FILTERS', {
        name: this.widgetParams.reportName,
        item: {
          common: {
            organisation: [this.workshopId],
            postcodeFrom: '',
            postcodeTo: '',
          },
          custom: {},
        },
      })
      this.$router.push({
        path: `/reports/${this.widgetParams.reportName}`,
      })
    },
  },
}
</script>
<template>
  <div>
    <v-flex class="pl-4 pb-4">
      <p class="subheading">{{ $t(`reports__${widgetParams.reportName}`) }} <span style="color:gray">({{ widgetParams.dateLabel }})</span></p>
    </v-flex>
    <OilVolumeChange
      v-if="workshopId"
      :ext-params="widgetParams.params"
      :override-params="overrideParams" />
  </div>
</template>
